export default __webpack_public_path__ + "static/media/contactus_banner.4b50010a.png";